import { createI18nText } from '@hilma/netina2all';

const purchaseStationText = createI18nText({
	he: {
		selectStation: 'בחר תחנה מהרשימה או מהמפה',
		stations: 'תחנות',
		wereFound: 'נמצאו',
		closeToMe: 'קרוב אליי',
		address: 'הקלידו את כתובתכם כדי למצוא את התחנות הקרובות ביותר'
	},
	en: {
		selectStation: 'Select a station from the list or from the map',
		stations: 'stations',
		wereFound: 'were found',
		closeToMe: 'close to me',
		address: 'Type in your address to find the nearest stations'

	}
});

export default purchaseStationText;